import i18n from '@/core/i18n';
import { IntegrationDataType } from '@/modules/common/types/integrations';

const INTEGRATION_DATA_TYPE_TRANSLATION_KEYS: Record<IntegrationDataType, string> = {
  [IntegrationDataType.TEAM_MEMBER]:
    'authenticated.settings:pages.integrations.table.dataTypes.teamMember',
  [IntegrationDataType.PROJECT]:
    'authenticated.settings:pages.integrations.table.dataTypes.project',
  [IntegrationDataType.CLIENT]: 'authenticated.settings:pages.integrations.table.dataTypes.client',
  [IntegrationDataType.ASSIGNMENT]:
    'authenticated.settings:pages.integrations.table.dataTypes.assignment',
  [IntegrationDataType.TIME_LOG]:
    'authenticated.settings:pages.integrations.table.dataTypes.timeLog',
  [IntegrationDataType.FINANCE]:
    'authenticated.settings:pages.integrations.table.dataTypes.finance',
  [IntegrationDataType.TIME_OFF]:
    'authenticated.settings:pages.integrations.table.dataTypes.timeOff',
};

/**
 * Formats an array of integration data types into a comma-separated translated string
 * @param dataTypes - Array of integration data types to format
 * @returns Formatted string with translated data type names separated by commas, or null if no valid translations exist
 */
export function formatIntegrationDataTypes(dataTypes: IntegrationDataType[]): string | null {
  const translatedTypes = dataTypes
    .filter(dataType => dataType in INTEGRATION_DATA_TYPE_TRANSLATION_KEYS)
    .map(dataType => i18n.t(INTEGRATION_DATA_TYPE_TRANSLATION_KEYS[dataType]));

  return translatedTypes.length > 0 ? translatedTypes.join(', ') : null;
}
